// extracted by mini-css-extract-plugin
var _1 = "ImportFilesConfirmation-module__section--iuce8";
export { _1 as "section" }
